import HttpClient from './client';
import { ENDPOINTS, constructApiEndpoint } from './endpoints';
export const loadPreferences = async () => {
  const httpClient = new HttpClient();
  const apiUrl = constructApiEndpoint(ENDPOINTS.LOAD_PREFERENCES);
  return httpClient.get(apiUrl);
};
export const savePreferences = async (payload, additionalPayloadInfo) => {
  const httpClient = new HttpClient();
  const apiUrl = constructApiEndpoint(ENDPOINTS.SAVE_PREFERENCES);
  return httpClient.postFormData(apiUrl, payload, additionalPayloadInfo);
};